import { Controller } from "@hotwired/stimulus"
import { da } from "date-fns/locale"
import { DateTime } from "luxon"

// Connects to data-controller="tz-dates-field"
export default class extends Controller {
  static targets = ['endDate', 'startDate', 'parentStartDate']
  static outlets = ['tz-dates-field']

  connect() {
    if (this.element.dataset.validate == "true") {
      this.element.closest("form").addEventListener("submit", (event) => {
        this._get_children_outlets().forEach( (input) => {
          if (!input.checkValidity()) {
            event.preventDefault()
            input.reportValidity()
          }
        })
      })
    }
  }

  changeEndDate(event) {
    const startDateField = event.currentTarget
    this.endDateTarget.value = startDateField.value
  }

  endDateTargetConnected(target) {
    if(this.hasTzDatesFieldOutlet && this.tzDatesFieldOutlets.length < 2 && !target.value) target.value = this._addDays(new Date(), 0)
    else if(this.hasTzDatesFieldOutlet && !target.value) target.value = this._addDays(this.tzDatesFieldOutlets.at(-2).startDateTarget.value,
                                                                                  this.tzDatesFieldOutlets.length == 2 && this._getParentDatesOutlet() ? 0 : 1)
    this._setMinMaxDates(target)
  }

  startDateTargetConnected(target) {
    if(this.hasTzDatesFieldOutlet && this.tzDatesFieldOutlets.length < 2 && !target.value) target.value = this._addDays(new Date(), 0)
    else if(this.hasTzDatesFieldOutlet && !target.value) target.value = this._addDays(this.tzDatesFieldOutlets.at(-2).startDateTarget.value,
                                                                                  this.tzDatesFieldOutlets.length == 2 && this._getParentDatesOutlet() ? 0 : 1)
    this._setMinMaxDates(target)
  }

  changeMinMaxDate(event) {
    this._get_children_outlets().forEach( (target) => {
      target.min = this.startDateTarget.value + "T00:00"
      target.max = this.endDateTarget.value + "T23:59"
    })
  }

  _addDays(date, days=1) {
    if (!date) return `${date}T00:00`

    date = new Date(date)
    date = new Date(date.getTime() + days * 24 * 60 * 60 * 1000)

    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16)
  }

  _setMinMaxDates(target) {
    if(this.hasTzDatesFieldOutlet && !this.hasParentStartDateTarget) {
      let parentDatesOutlet = this._getParentDatesOutlet()
      if(!parentDatesOutlet) return
      target.min = parentDatesOutlet.startDateTarget.value + "T00:00"
      target.max = parentDatesOutlet.endDateTarget.value + "T23:59"
    }
  }

  _getParentDatesOutlet() {
    return this.tzDatesFieldOutlets.filter( (outlet) => outlet.hasParentStartDateTarget)[0]
  }

  _get_children_outlets() {
    return document.querySelectorAll('[data-tz-dates-field-tz-dates-field-outlet] input[type="datetime-local"]')
  }
}
